export enum ApiResponse {
  Authenticate = 'rel/authenticationResult',
  ReAuthenticate = 'rel/reAuthenticationResult',
  QuickQuoteProperties = 'rel/quickQuoteProperties',
  Destinations = 'rel/destinations',
  QuickQuote = 'rel/quickQuoteResult',
  PlanProperties = 'rel/planProperties',
  FullQuoteProperties = 'rel/fullQuoteProperties',
  FullQuote = 'rel/fullQuoteResult',
  PaymentProperties = 'rel/paymentProperties',
  PolicyPurchase = 'rel/purchasePolicyResult',
  PolicyProperties = 'rel/policyProperties',
  PreScreeningProperties = 'rel/preScreeningProperties',
  FinishPreScreening = 'rel/finishPreScreeningResult',  
  StartScreening = 'rel/startScreeningResult',
  FinishScreening = 'rel/finishScreeningResult',  
  ScreeningPricingOptions = 'rel/screeningPricingOptionsResult',
  CalculateMedicalFee = 'rel/calculateMedicalFeeResult'
}

export enum ApiAction {
  ReAuthenticate = 'reAuthenticate',
  Email = 'emailPolicy',
  ProvideQuickQuote = 'quickQuoteNac',
  FullQuoteProperties = 'fullQuoteProperties',
  ProvideFullQuote = 'fullQuote',
  StartPreScreening = 'startPreScreening',
  FinishPreScreening = 'finishPreScreening',
  StartScreening = 'startScreening',
  FinishScreening = 'finishScreening',
  PaymentSession = 'cardSession',
  PurchasePolicy = 'purchasePolicy',
  ScreeningPricingOptions = 'screeningPricingOptions',
  CalculateMedicalFee = 'calculateMedicalFee',
}

export enum ApiLink {
  PaymentProperties = 'rel/paymentProperties',
  PolicyProperties = 'rel/policyProperties',
  PaymentOption = 'rel/paymentOption',
  Certificate = 'rel/certificateOfInsurance',
  TravelInsuranceCards = 'rel/travelInsuranceCards',
  OtherInsurancesCards = 'rel/otherInsurancesCards',
  PreScreeningProperties = 'rel/preScreeningProperties',
  PdsDocument = 'rel/pds'
}

export enum ApiEntity {
  AdultOptions = 'rel/adultTravellerOptions',
  DependentOptions = 'rel/dependantTravellerOptions',
  PolicyAdults = 'rel/policyAdults',
  PolicyAdult = 'rel/policyAdult',
  PolicyDependents = 'rel/policyDependants',
  Titles = 'rel/titles',
  Plans = 'rel/plans',
  PaymentOption = 'rel/paymentOption',
  PlanBenefits = 'rel/planBenefits'
}

export enum ApiInsuranceType {
  TravelInsurance = 'travel-insurance',
  OtherInsurances = 'other-insurances',
}
